module.exports = __webpack_public_path__ + "static/media/loading-overlay.06644e77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/ProjectLoader/loading-overlay.svg
// module id = 1515
// module chunks = 2